<style scoped>
    .item{
        position: relative;
    }
    .label{
        position: relative;
        float: left;
        display: inline-block;
        vertical-align: top;
        width: 80px;
        padding-right: 6px;
        text-align: right;
        color: #888;
    }
    .label:before{
        content: ':';
        position: absolute;
        top: 0;
        right: 0;
    }
    .value{
        padding-left: 85px;
        white-space: normal;
    }
    .user-flow{
        margin-top: 20px;
    }
    .user-flow .value{
        padding-top: 3px;
        padding-left: 95px;
    }
    .expense-group-header, .expense-group-footer{
        text-align: center;
        font-weight: bold;
        padding: 6px;
    }
</style>
<template>
    <div class="item">
        <h2 class="text-center">采购入库单</h2>
        <div v-if="order.id">
            <div class="line">
                <div class="label">入库单号</div>
                <div class="value">
                    <span v-if="order.uid">
                        {{order.uid}}
                        <span class="color-error" v-if="order.del">[<Icon type="trash-a" size="13"></Icon> 已废弃]</span>
                    </span>
                    <span v-else>-</span>
                </div>
            </div>
            <div class="line">
                <div class="label">仓库入库单号</div>
                <div class="value">{{order.relate_uid || '-'}}</div>
            </div>
            <div class="line">
                <div class="label">入库时间</div>
                <div class="value">{{order.in_date}}</div>
            </div>
            <div class="line">
                <div class="label">仓库</div>
                <div class="value">{{warehouse}}</div>
            </div>
            <div class="line">
                <div class="label">关联合同</div>
                <div class="value">
                    <ViewerItem type="Contract" :model_id="order.contract.id" v-if="order.contract">
                        <span class="link">{{order.contract.uid}}</span>
                        <span>{{order.contract.name}}</span>
                    </ViewerItem>
                    <span v-else>-</span>
                </div>
            </div>
            <div class="line">
                <div class="label">备注</div>
                <div class="value">
                    <span v-html="order.remark" v-if="order.remark"></span>
                    <span v-else>无</span>
                </div>
            </div>
            <Table size="small" :columns="columns" :data="order.stock_in_order_items"></Table>
        </div>
        <div class="text-center" v-else>
            <Spin size="large" fix></Spin>
        </div>
    </div>
</template>
<script>
    import ViewerItem from '../item';
    import Attachments from '../../../components/file/attachments';
    import UserFlowBase from '../../../components/flow/user_flow_base';
    export default {
        components: { ViewerItem, Attachments, UserFlowBase },
        props: {
            model_id: {
                type: Number
            }
        },
        data(){
            return {
                loading: false,
                order: {stock_in_order_items: []},
                columns: [
                    {
                        title: '存货编号',
                        align: 'center',
                        width: 80,
                        key: 'stock_uid',
                        fixed: 'left'
                    },
                    {
                        title: '存货名称',
                        align: 'center',
                        width: 120,
                        key: 'stock_name'
                    },
                    {
                        title: '数量',
                        align: 'center',
                        width: 100,
                        key: 'qty',
                        render: (h, params)=>{
                            let row = params.row;
                            return h('span', Util.formatPrice(row.qty));
                        }
                    },
                    {
                        title: '单价(￥)',
                        align: 'center',
                        width: 100,
                        key: 'unit_price',
                        render: (h, params)=>{
                            let row = params.row;
                            return h('span', Util.formatPrice(row.unit_price));
                        }
                    },
                    {
                        title: '存货金额(￥)',
                        align: 'center',
                        width: 100,
                        key: 'stock_price',
                        render: (h, params)=>{
                            let row = params.row;
                            return h('span', Util.formatPrice(row.stock_price));
                        }
                    },
                    {
                        title: '其他金额(￥)',
                        align: 'center',
                        width: 100,
                        key: 'other_price',
                        render: (h, params)=>{
                            let row = params.row;
                            return h('span', Util.formatPrice(row.other_price));
                        }
                    },
                    {
                        title: '总金额(￥)',
                        align: 'center',
                        width: 100,
                        key: 'total_price',
                        render: (h, params)=>{
                            let row = params.row;
                            return h('span', Util.formatPrice(row.total_price));
                        }
                    },
                    {
                        title: '税(￥)',
                        align: 'center',
                        width: 100,
                        key: 'tax',
                        render: (h, params)=>{
                            let row = params.row;
                            return h('span', Util.formatPrice(row.tax));
                        }
                    },
                    {
                        title: '备注',
                        width: 150,
                        align: 'center',
                        key: 'remark'
                    },
                ]
            }
        },
        computed: {
            warehouse(){
                if(this.order.warehouse){
                    return this.order.warehouse.name;
                }else{
                    return '-';
                }
            }
        },
        created(){
            this.getOrder();
        },
        mounted(){
            //
        },
        methods: {
            getOrder(){
                Util.ajax.get(Util.api.stock_in_order_detail, {
                    params: {
                        id: this.model_id
                    }
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    if(res.code === 1){
                        this.order = res.data.stock_in_order;
                    }else{
                        this.$Modal.error({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.$Modal.error({
                        title: '错误',
                        content: e.message
                    });
                });
            },
            formatPrice(price){
                return Util.formatPrice(price);
            }
        }
    }
</script>
